import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Multiple approaches for cross-browser/mobile compatibility

    // 1. Standard window scroll
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // 2. Fallback for older browsers
    window.scrollTo(0, 0);

    // 3. Document element scroll (for some mobile browsers)
    document.documentElement.scrollTop = 0;

    // 4. Body scroll (for some mobile browsers)
    document.body.scrollTop = 0;

    // 5. Main content container (for layouts with overflow-y-auto)
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      mainContent.scrollTop = 0;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
